/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ when: NonNullable<unknown> }} Tea_Grade_Stock_Lot_CreatedInputs */

const vi_tea_grade_stock_lot_created = /** @type {(inputs: Tea_Grade_Stock_Lot_CreatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tạo lô ${i?.when}`)
};

/**

* @param {Tea_Grade_Stock_Lot_CreatedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_grade_stock_lot_created = /** @type {((inputs: Tea_Grade_Stock_Lot_CreatedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Grade_Stock_Lot_CreatedInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_grade_stock_lot_created(inputs)
});